import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DeviceGroup_Interface } from 'src/app/Interface/DeviceGroup_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';

@Component({
  selector: 'app-DeviceGroupTreeview',
  templateUrl: './DeviceGroupTreeview.component.html',
  styleUrls: ['./DeviceGroupTreeview.component.scss']
})
export class DeviceGroupTreeviewComponent implements OnInit {


  @Output() Outer_DataList_DeviceGroup_Selected=new EventEmitter<Array<DeviceGroup_Interface>>();

  Token:String=""
  Procssing:boolean=false
  DataList_DeviceGroup_Parent:Array<DeviceGroup_Interface>=[]
  DataList_DeviceGroup_Child:Array<DeviceGroup_Interface>=[]
  DataList_DeviceGroup_Selected:Array<DeviceGroup_Interface>=[]
  constructor(
    private DeviceGroup_Service:DeviceGroupService,
    private Alertify_Service:AlertifyService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.ReadData_DeviceGroup()
  }

  ReadData_DeviceGroup(){
    this.Procssing=true
    this.DeviceGroup_Service.GetTree(this.Token).subscribe(
      data=>{
        this.DataList_DeviceGroup_Parent=data['parent']
        this.DataList_DeviceGroup_Child=data['child']

        for(let item of this.DataList_DeviceGroup_Parent)
        {
          item.child=[]
          for(let itemdetail of this.DataList_DeviceGroup_Child)
          {
            if(itemdetail.parent==item.id)
            {
              itemdetail.del=true
              item.child.push(itemdetail)
            }
          }
        }

        this.Procssing=false

        this.SetSelect_DeviceGroup()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  OnChangeSelect_DeviceGroup(item:DeviceGroup_Interface)
  {
    item.del=!item.del
    this.SetSelect_DeviceGroup()

  }

  SetSelect_DeviceGroup()
  {
    this.DataList_DeviceGroup_Selected=[]
    for(let item of this.DataList_DeviceGroup_Parent)
    {
      for(let itemdetail of item.child)
      {
        if(itemdetail.del==true)
        {
          this.DataList_DeviceGroup_Selected.push(itemdetail)
        }
      }
    }

    this.Outer_DataList_DeviceGroup_Selected.emit(this.DataList_DeviceGroup_Selected)

  }

}
